const isDev = () => process.env.TS_ENV !== 'prod';

export default isDev;
